import { render } from "./ChuckNorris.vue?vue&type=template&id=f939fc5c"
import script from "./ChuckNorris.vue?vue&type=script&lang=js"
export * from "./ChuckNorris.vue?vue&type=script&lang=js"

import exportComponent from "/home/ipszzy/Repositories/vue-command/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__